// react
import React from 'react';


export default function BlockMap() {
    return (
        <div className="block-map block">
            <div className="block-map__body">
                <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.883138119138!2d80.21858625063804!3d13.043109816788432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5266e5ae38417f%3A0xbde00ea3c88b926c!2sCODA%20Technology%20Solutions%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1581193787310!5m2!1sen!2sin"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                />
            </div>
        </div>
    );
}



